module.exports = __webpack_public_path__ + "static/media/icon_141.8d03083c.png";